import React from 'react';
import { ReactComponent as CloseIcon } from '../../../assets/shared/ic-shared-close.svg';

export enum CloseButtonColor {
  Black,
  White,
  Gray,
}

export enum CloseButtonSize {
  Small,
  Medium,
  Large,
}
export interface IProps extends Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  'onClick' | 'color' | 'size'
> {
  onClick?: () => void;
  color?: CloseButtonColor;
  size?: CloseButtonSize;
  circle?: boolean;
}

export const CloseButton = ({ onClick, id, color, size, className, circle, ...rest }: IProps) => {
  const getColorValue = () => {
    switch (color) {
      case CloseButtonColor.Gray: {
        return 'secondary';
      }
      case CloseButtonColor.Black: {
        return 'primary';
      }
      case CloseButtonColor.White: {
        return 'primary-inverse';
      }
      default: {
        return 'secondary';
      }
    }
  };

  const getSizeValue = () => {
    switch (size) {
      case CloseButtonSize.Small: {
        return 'h-[16px] w-[16px]';
      }
      case CloseButtonSize.Medium: {
        return 'h-[20px] w-[20px]';
      }
      case CloseButtonSize.Large: {
        return 'h-[24px] w-[24px]';
      }
      default: {
        return 'h-[20px] w-[20px]';
      }
    }
  };
  return (
    <div
      className={`${className} flex flex-row ${
        color !== CloseButtonColor.White && 'hover:bg-surface-primary-bw-02'
      } rounded-full p-[2px] w-fit h-fit ${circle ? 'rounded-full bg-surface-primary-bw-01 shadow-sm' : ''}`}>
      <button className='hover:cursor-pointer' id={id} onClick={onClick} type='button' {...rest}>
        <CloseIcon className={`text-text-main-${getColorValue()} ${getSizeValue()}`} />
      </button>
    </div>
  );
};
